export default __webpack_public_path__ + "static/media/arrows-h.2408d737.svg";